import { Routes } from "@angular/router";
import { InvoicePreviewComponent } from "./invoice-preview.component";
import { InvoicePreviewSummaryComponent } from "./invoice-preview-summary/invoice-preview-summary.component";
import { InvoicePreviewOrderTrackingLineComponent } from "./invoice-preview-order-tracking-line/invoice-preview-order-tracking-line.component";
import { InvoicePreviewBillingNotesListingComponent } from "./invoice-preview-billing-notes-listing/invoice-preview-billing-notes-listing.component";
import { InvoicePreviewDispositionComponent } from "./invoice-preview-disposition/invoice-preview-disposition.component";

export const invoicPreviewRoutes: Routes = [
  { path: "", component: InvoicePreviewComponent },
  {
    path: "invoice-preview-summary/:id",
    component: InvoicePreviewSummaryComponent,
  },
  {
    path: "invoice-preview-tracking-detail/:id",
    component: InvoicePreviewOrderTrackingLineComponent,
  },
  {
    path: "order-notes/:id",
    component: InvoicePreviewBillingNotesListingComponent,
  },
  {
    path: "disposition/:id",
    component: InvoicePreviewDispositionComponent,
  },
];
